// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b2c05c3b34bf03d3","3185":"ae8ba9ba690f9479"}[chunkId] + ".css";
};